/**
 * The folder pane's tree, from the live folders it lists: a folder whose parent isn't among them (the parent is in
 * Trash or archived; the folder was restored on its own) is shown at the root. The tree only draws a folder under
 * a parent it has, so it was drawn nowhere, though it was live.
 */
export function withOrphansAtRoot<T extends { id?: string; parentId?: string | null }>(folders: T[]): T[] {
  const listed = new Set(folders.map((folder) => folder.id));
  return folders.map((folder) => (folder.parentId && !listed.has(folder.parentId) ? { ...folder, parentId: null } : folder));
}
